import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import "../UserDashboardHome/UserDashboardHome.css";
import "../StatementTable/StatementTable.css";
import localeText from "../../../../locale";
import { Toast } from "primereact/toast";
import { Column } from "primereact/column";
import handleLocale from "../../../../utilities/LocaleSwitch";
import { FilterMatchMode } from "primereact/api";
import { locale } from "../../../../utilities/locale/locale";
import UserEditService from "../../../../service/UserEditService";
import { formatDate } from "../../../../utilities/formatDate";
import { formatPrice } from "../../../../utilities/formatPrice";
import { typeTransfer } from "../WithdrawIntent/WithdrawIntent";
//import { Button } from 'primereact/button';

const ListUserWithdrawRequests = ({ retryFetch, setRetryFetch }) => {
  const [loading, setLoading] = useState(false);
  const [withdrawRequests, setWithdrawRequests] = useState([]);

  const userEditService = new UserEditService();
  const toast = useRef(null);

  // eslint-disable-next-line no-unused-vars
  const [filters2, setFilters2] = useState({
    title: { value: null, matchMode: FilterMatchMode.CONTAINS },
    "user.username": { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  useEffect(() => {
    let cancel = false;

    if (retryFetch) fetchWithdrawRequests(cancel).finally(() => setRetryFetch(false));

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [retryFetch]);

  async function fetchWithdrawRequests(cancel) {
    try {
      setLoading(true);
      const res = await userEditService.getAllUserWithdrawRequests(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username")
      );
      if (cancel) return;

      if (res.messageCode !== 200001) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        if (res.messageCode === 500000) console.log(res);
        setLoading(false);
      } else {
        setWithdrawRequests(res.result);
        setLoading(false);
      }
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
      setLoading(false);
      console.log(e);
    }
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  return (
    <div>
      <Toast ref={toast} />

      <h3 className="my-4">{localeText("withdrawRequests")}</h3>
      <hr />

      <DataTable
        className="mt-4 mb-6 p-datatable-customers"
        value={withdrawRequests}
        paginator
        responsiveLayout="scroll"
        loading={loading}
        dataKey="id"
        filters={filters2}
        filterDisplay="row"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate={localeText("showingFirstToLast")}
        rows={10}
        rowsPerPageOptions={[10, 20, 50]}
      >
        <Column
          header={`Email (PayPal) | ${localeText("bank")}`}
          body={(withdrawRequest) => {
            const isBankTransfer = withdrawRequest.typeWithdraw === typeTransfer.BANK;
            const isPaypalTransfer = withdrawRequest.typeWithdraw === typeTransfer.PAYPAL;
            return (
              <>
                {isPaypalTransfer && <p>{withdrawRequest.paypalEmailToTransfer}</p>}

                {isBankTransfer && (
                  <>
                    <p className="mb-1 mt-0">
                      {localeText("name")}: {`${withdrawRequest?.accountOwner}`}{" "}
                    </p>
                    <p className="mb-1 mt-0">
                      {localeText("bank")}: {`${withdrawRequest.bankname}`}
                    </p>
                    <p className="mb-0 mt-0">
                      {localeText("bankAccountNumber")}: {`${`${withdrawRequest?.iban}`}`}
                    </p>
                  </>
                )}
              </>
            );
          }}
        />
        <Column
          header={localeText("requestDate")}
          body={(withdrawRequest) => {
            return (
              <>
                {withdrawRequest.dateRequest && (
                  <div>{formatDate(withdrawRequest.dateRequest)}</div>
                )}
              </>
            );
          }}
        />
        <Column
          header={localeText("processDate")}
          body={(withdrawRequest) => {
            return (
              <>
                {withdrawRequest.dateProcess && (
                  <div>{formatDate(withdrawRequest.dateProcess)}</div>
                )}
              </>
            );
          }}
        />
        <Column
          field="amountRequested"
          header={localeText("amountRequested")}
          body={(withdrawRequest) => {
            let localeISO;
            let currentCurrency;

            localeISO = handleLocale(locale);
            currentCurrency = withdrawRequest.currency;

            return (
              <p>
                {currentCurrency}{" "}
                {withdrawRequest.amountRequested.toLocaleString(localeISO, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </p>
            );
          }}
        />
        <Column
          field="amountToDeposit"
          header={localeText("amountToDeposit")}
          body={(withdrawRequest) => {
            let currentCurrency;
            currentCurrency = withdrawRequest.currency;
            return (
              <p>
                {currentCurrency} {formatPrice(withdrawRequest.amountToDeposit)}
              </p>
            );
          }}
        />
        <Column
          field="fee"
          header={capitalizeFirstLetter(localeText("withdrawFee"))}
          body={(withdrawRequest) => {
            let currentCurrency;
            currentCurrency = withdrawRequest.currency;

            return (
              <p>
                {currentCurrency} {formatPrice(withdrawRequest.fee)}
              </p>
            );
          }}
        />
        <Column
          header={localeText("status")}
          body={(withdrawRequest) => {
            return (
              <>
                {withdrawRequest.status === "COMPLETED" && (
                  <span
                    className="team-member-role text-0 p-1 border-round"
                    style={{ backgroundColor: "#46a748" }}
                  >
                    {withdrawRequest.status === "COMPLETED" && localeText("completed")}
                  </span>
                )}
                {withdrawRequest.status === "PROCESSING" && (
                  <span
                    className="team-member-role text-0 p-1 border-round"
                    style={{ backgroundColor: "#F7B005" }}
                  >
                    {withdrawRequest.status === "PROCESSING" && localeText("processing")}
                  </span>
                )}
              </>
            );
          }}
        />
      </DataTable>
    </div>
  );
};

export default ListUserWithdrawRequests;
